// =========================================================
// * Vuetify Material Dashboard PRO - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueResource from "vue-resource";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/base";
import "./plugins/chartist";
import "./plugins/vee-validate";
import "./plugins/vue-world-map";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import FlashMessage from "@smartweb/vue-flash-message";
import VueTheMask from "vue-the-mask";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VCurrencyField from "v-currency-field";
import { VTextField } from "vuetify/lib";

Vue.component("v-text-field", VTextField);
Vue.use(VCurrencyField, {
  locale: "pt-BR",
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true,
});

Vue.use(VueTheMask);

const options = {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  icon: true,
};

Vue.use(Toast, options);

Vue.config.productionTip = false;
Vue.use(FlashMessage);

Vue.$globalEvent = new Vue();

Vue.use(VueResource);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mounted() {
    Vue.$globalEvent.$on("httpError", (error) => {
      if (error) {
        if (error.status) {
          if (error.showException && error.status === 401) {
            if (error.body && error.body.detail) {
              this.$toast.error(error.body.detail);
            } else {
              this.$toast.error({ title: this.$t("unauthorized") });
            }
            router.push({ name: "/auth" });
          } else if (error.showException && error.status === 403) {
            this.$toast.error(this.$t("unauthorized"));
            router.push({ name: "/auth" });
          } else if (
            error.showException &&
            error.status === 412 &&
            error.body &&
            error.body.detail &&
            error.body.detail.toLowerCase().indexOf("expired") > -1
          ) {
            this.$toast.error(this.t("session_expired"));
            router.push({ name: "/auth" });
          } else if (error.showException && error.status >= 500) {
            this.$toast.error(error.message);
          }
        } else {
          if (error.status === 0) {
            this.$toast.error(error);
            return;
          } else {
            this.$toast.error(error);
          }
        }
      }
    });
  },
  render: (h) => h(App),
}).$mount("#app");
